import {FilmStripImage} from "./style/StyledImage";
import {ImageButton} from "./ImageButton";
import {Container, FilmStrip, FilmStripItem, HeaderDiv, HorizontalDiv} from "./style/StyledDiv";
import React, {useState} from "react";
import { ContainerCenter} from "./style/StyledGrid";
import { useRef } from "react";
import {TOPICS} from "./services/constants";
import {Content} from "./Content";
import {useSwipe} from "./services/swipe";





type MainProps = {

};

export const Main: React.FC<MainProps> = ({}) =>
{
    const swipe = useSwipe((dir) => {
        console.log("Swiped:", dir);
    });
    const [count, setCount] = useState<number>(0);
    const [action, setAction] = useState<string>("paused")

    const [paused, setPaused] = useState<boolean>(false);

    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const windowSize = TOPICS.length*2;

    const range = (start: number, end: number): number[] => {
        return Array.from(

            { length: end - start + 1 },
            (_, i) => start + i
        );
    };

    const ref = useRef(null);
    const itemRefs = useRef<Array<HTMLDivElement | null>>([]);
    const ITEM = 20; // vw
    const GAP = 1;  // vw
    const STEP = ITEM + GAP;

    function pauseResume(ref:any, item:any, itemKey: any) {
        if(paused)
        {
            ref.style.animationPlayState = "running";
            setPaused(false)
        }else {
            setCurrentIndex(itemKey % TOPICS.length)
            ref!.style.animationPlayState = "paused"; // pause animation
            setPaused(true);
        }

    }
    const handleButtonClick = (el:any, itemKey: any): void => {
        console.log("Callback executed in parent"+count);
        pauseResume(ref?.current,el,itemKey);
    };

    return (
        <div >
            <Container>
                <HeaderDiv></HeaderDiv>
                    <FilmStrip amount={TOPICS.length}  {...swipe} ref={ref} transition={count===0?"none":"left 0.5s linear"} position={count%TOPICS.length} action={action} windowSize={TOPICS.length} gap={GAP+"vw"} itemWidth={ITEM+"vw"}>
                        {range(0,windowSize*2).map((item, index) => (
                            <FilmStripItem key={index}
                                           onMouseUp={x => handleButtonClick(x,index)}
                                           ref={el => {
                                itemRefs.current[index % TOPICS.length] = el; // el is HTMLDivElement | null
                            }}   itemWidth={ITEM+"vw"}>
                                <FilmStripImage key={index+"image"} src={TOPICS[(index)%TOPICS.length].imageSrc} blur={index%TOPICS.length===currentIndex || !paused?"0px":"5px"} ></FilmStripImage>
                            </FilmStripItem>
                        ))}
                    </FilmStrip>
                    <Content topic={TOPICS[(currentIndex)%TOPICS.length]} ></Content>

            </Container>




        </div>
    );
}
